























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { yandexMap, ymapMarker } from 'vue-yandex-maps';
import { ConfigApi } from "fs-pb-vue2/services/api/ConfigApi";
import { MapData } from "fs-pb-vue2/data/mapData";
import Preloader from "@/components/app/Preloader.vue";

@Component({ components: { yandexMap, ymapMarker, Preloader }})
export default class MapComponent extends Vue {

  @Watch('markerType', { immediate: true })
  typeChanged(val: string): void {
    this.$nextTick(() => this.mapLoading = false);
    if (this.companies[0]) {
      this.coords = this.companies[0].Cords;
      this.choosenCity = this.companies[0].City;
    }
    this.mapLoading = true;
  }

  @Watch('$route.fullPath', { immediate: true })
  routeChange(val: string): void {
    if (val.includes('#modal')) {
      const compId: string = val.substring(val.indexOf('[') + 1, val.indexOf(']'));
      this.selectedCompany = this.companies.find((comp: any) => comp.CompanyId === compId);
      console.log(this.selectedCompany)
      if (this.selectedCompany)
        this.openModal();
    }
  }

  markerTypes: Array<any> = [
    {
        label: 'Отделения',
        value: 'office'
    },
    {
        label: 'Банкоматы',
        value: 'atm'
    },
    {
        label: 'Платежные терминалы',
        value: 'terminal'
    },
  ];

  markerType: any = this.markerTypes[0];

  coords: Array<any> = [
    46.19850705885551,
    33.81434286865233,
  ];

  mapData: MapData = null;

  mapLoading: boolean = false;

  cityList: Array<string> = [];

  choosenCity: string = '';

  selectedCompany: any = null;

  isModal: boolean = false;

  settings: any = {
    apiKey: '720e664b-d70f-4bb2-a2f4-3eec62b75e86',
    lang: 'ru_RU',
    coordorder: 'latlong',
    enterprise: true,
    version: '2.1'
  };

  officeTemplate: any = {
    'Что здесь:': 'Type',
    'Обслуживание физических лиц:': 'WorkingTime',
    'Подразделение банка:': 'AdressName',
    'Обслуживание юридических лиц:': 'WorkingTime',
    'Адрес отделения:': 'Adress',
    'E-mail:': 'Email'
  }

  atmTemplate: any = {
    'Что здесь:': 'Type',
    'Адрес банкомата:': 'Adress',
    'Номер устройства самообслуживания:': 'DeviceNumber',
    'GPS-координаты': 'Cords',
  }

  terminalTemplate: any = {
    'Что здесь:': 'Type',
    'Режим работы терминала:': 'WorkingTime',
    'Номер устройства:': 'DeviceNumber',
    'Адрес платежного терминала': 'Adress',
    'Место установки': 'AdressName',
  }

  // get hintTemplate(): string {
  //   return `
  //     <div class="my-hint">
        
  //     </div>
  //   `;
  // }

  determineObjectType(type: string): string {
    switch (type.toLowerCase()) {
      case 'office':
        return 'Отделение';
      case 'atm':
        return 'Банкомат';
      case 'terminal':
        return 'Платежный терминал';
      default:
        return 'Отделение';
    }
  }


  balloonTemplate(comp: any): string {
    const objectType = this.determineObjectType(comp.Type);
    return `
      <div class="my-balloon">
        <span class="street">${comp.Street}</span>
        <p>${objectType}</p>
        ${comp.DeviceNumber ? `<span class="device">${comp.DeviceNumber}</span>` : ''}
        <span class="add">${comp.AdressName}</span>
        <span class="time">${comp.WorkingTime}</span>
        <span class="adress">${comp.Adress}</span>
        <a class="way" href="https://yandex.ru/maps/?rtext=~${comp.Cords}" target="_blank">Построить маршрут</a>
        <a class="more" href="#modal[${comp.CompanyId}]">Подробнее</a>
      </div>
    `;
  }

  get companies(): Array<any> {
    if (!this.mapData)
      return [];
    let companies: Array<any> = 
      this.mapData.Companies.filter((comp: any) => comp.Adress.length);
    if (this.markerType)
      companies = companies.filter((comp: any) => comp.Type === this.markerType.value);
    this.cityList = companies.map((comp: any) => comp.City);
    return companies;
  }

  markerIcon(type: string): string {
    const res: any = {
      layout: 'default#imageWithContent',
      imageHref: require('./../../../public/img/office.png'),
      imageSize: [36, 54],
      imageOffset: [-18, -54],
      content: '',
      contentOffset: [0, 15],
      contentLayout: ''
    };

    switch (type) {
      case 'office':
        res.imageHref = require('./../../../public/img/office.png');
        break;
      case 'atm':
        res.imageHref = require('./../../../public/img/atm.png');
        break;
      case 'terminal':
        res.imageHref = require('./../../../public/img/terminal.png');
        break;
      default:
        res.imageHref = require('./../../../public/img/office.png');
        break;
    }
    return res;
  }

  findCityOnMap(): void {
    if (this.choosenCity.length) {
      this.$nextTick(() => this.mapLoading = false);
      this.coords = this.companies.find((comp: any) => comp.City === this.choosenCity).Cords;
      this.mapLoading = true;
    }
  }

  openModal(): void {
    this.isModal = true;
  }

  closeModal(): void {
    this.isModal = false;
    this.updateLocation();
  }

  openBlank(url: string): void {
    if (url.length)
      window.open(url, '_blank');
  }

  updateLocation(): void {
    if (this.$route.fullPath.includes('#modal')) {
      const link = document.createElement("a");
      link.href = '#'
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.selectedCompany = null;
    }
  }
  
  async mounted(): Promise<void> {
    // await loadYmap(this.settings);
    this.mapLoading = true;
    this.updateLocation();
    try {
      this.mapData = await ConfigApi.getMapData();
      if (this.mapData.Companies.length > 0) {
        const cityCrimea = this.mapData.Companies.find((comp: any) => comp.City.includes("Симферополь"));
        if (cityCrimea) {
          this.coords = [
            parseFloat(cityCrimea.Cords[0]),
            parseFloat(cityCrimea.Cords[1])
          ];
          this.choosenCity = cityCrimea.City;
        } else {
          this.coords = this.mapData.Companies[0].Cords;
          //this.cityList = this.companies.map((comp: any) => comp.City);
        }
      }
    } catch(e: any) {
      this.mapData = null;
      console.warn(e);
    } finally {
      this.mapLoading = false;
    }
  }

}
